/* eslint react/prop-types: off */
import { useEffect, useState } from 'react';
import { EstadosDocs } from './EstadoDocs';
import './reclamo.css';
import { useCookies } from 'react-cookie';
export function DocSinAbrir({ id, documento, link, ultMod, theme, estadoDocs, setEstadoDocs, obs, setObs, modoEliminar, docsSeleccionados, setDocsSeleccionados, setModoEliminar }) {
  const [cookies] = useCookies(['user']);
  // Texto Cargar
  let texto;
  switch (documento) {
    case 1:
      texto = 'DENUNCIA ADMINISTRATIVA';
      break;
    case 2:
      texto = 'REGISTRO DE CONDUCTOR';
      break;
    case 3:
      texto = 'CEDULA VERDE';
      break;
    case 4:
      texto = 'PRESUPUESTO';
      break;
    case 5:
      texto = 'FOTOS COLOR DEL DAÑO';
      break;
    case 6:
      texto = 'CERTIFICADO DE COBERTURA';
      break;
    case 7:
      texto = 'VTV VIGENTE';
      break;
    case 8:
      texto = 'FORMULARIO 08';
      break;
    case 9:
      texto = 'DENUNCIA POLICIAL';
      break;
    case 10:
      texto = 'LESIONES';
      break;
    case 11:
      texto = 'CROQUIS';
      break;
    case 12:
      texto = 'DAÑO A PROPIEDAD';
      break;
    case 13:
      texto = 'FOTOS DE DAÑOS, ASEGURADO AGROSALTA';
      break;
    case 14:
      texto = 'CARTA DE NO DESTRUCCIÓN TOTAL';
      break;
    case 15:
      texto = 'CARTA DE FRANQUICIA';
      break;
    default:
      texto = 'Texto no disponible';
  }
  let texto2;
  switch (documento) {
    case 1:
      texto2 = 'denunciaAdministrativa';
      break;
    case 2:
      texto2 = 'registro';
      break;
    case 3:
      texto2 = 'cedula';
      break;
    case 4:
      texto2 = 'presupuesto';
      break;
    case 5:
      texto2 = 'fotos';
      break;
    case 6:
      texto2 = 'cobertura';
      break;
    case 7:
      texto2 = 'vtv';
      break;
    case 8:
      texto2 = 'formulario08';
      break;
    case 9:
      texto2 = 'denunciaPolicial';
      break;
    case 10:
      texto2 = 'lesiones';
      break;
    case 11:
      texto2 = 'croquis';
      break;
    case 12:
      texto2 = 'danioPropiedad';
      break;
    case 13:
      texto2 = 'fotosAseguradoAGS';
      break;
    case 14:
      texto2 = 'noDestruccionTotal';
      break;
    case 15:
      texto2 = 'cartaFranquicia';
      break;
    default:
      texto2 = 'Texto no disponible';
  }
  const linkArray = link?.split(',');
  const [modoEliminarDocs, setModoEliminarDocs] = useState({});
  return (
    <article className='contenedorDocSinAbrir'>
      <div className='headerDocSinAbrir'>
        <h3 className={theme === 1 ? 'tituloDocSinAbrir me-3' : 'tituloDocSinAbrirDark me-3'}>{texto}</h3>
        <div className='d-flex gap-2'>
          <EstadosDocs
            cookies={cookies}
            estado={estadoDocs[texto2]}
            theme={theme}
            onChange={nuevoValor => {
              setEstadoDocs(prev => ({
                ...prev,
                [texto2]: nuevoValor,
              }));
              if (nuevoValor !== 903) {
                setObs(prev => ({
                  ...prev,
                  [texto2]: '',
                }));
              }
              setModoEliminarDocs(prev => ({
                ...prev,
                [texto2]: nuevoValor === 903 || obs?.[texto2]?.trim() !== '',
              }));
            }}
          />
          <div style={{ marginLeft: 'auto', gap: '10px' }} className='d-flex'>
            <label className='custom-checkbox'>
              <input
                checked={estadoDocs[texto2] === 904}
                type='checkbox'
                disabled={cookies?.user?.titulo === 'lector'}
                onChange={() => {
                  if (estadoDocs[texto2] !== 904) {
                    setEstadoDocs(prev => ({
                      ...prev,
                      [texto2]: 904,
                    }));
                    setObs(prev => {
                      const actualizado = { ...prev };
                      delete actualizado[texto2];
                      return actualizado;
                    });
                  }
                }}
              />
              <span className='checkmark'></span>
            </label>
          </div>
        </div>
      </div>
      <div style={{ marginTop: '10px' }}>
        {linkArray?.map((a, index) => (
          <div key={index} className='d-flex align-items-center justify-content-between mb-1'>
            <button
              type='button'
              disabled={cookies?.user?.titulo === 'lector'}
              className={theme === 1 ? 'textoDocCargado' : 'textoDocCargadoDark'}
              style={{ border: 'none', background: 'none' }}
              onClick={async () => {
                try {
                  const res = await fetch(`https://reclamosback.agsseguros.online/apiReclamos/files/genTempEmp?id=${id}&tipo=${texto2}&archivo=${encodeURIComponent(a)}`);
                  if (!res.ok) {
                    const text = await res.text();
                    console.error('Error backend:', text);
                    return;
                  }
                  const data = await res.json();
                  window.open(data.url, '_blank');
                } catch (err) {
                  console.error(err);
                }
              }}>
              {a.length > 50 ? a.slice(0, 50) + '...' : a}
            </button>
            {(modoEliminar || modoEliminarDocs[texto2]) && a && (
              <label className='switchEliminarDoc'>
                <input
                  type='checkbox'
                  disabled={cookies?.user?.titulo === 'lector'}
                  checked={docsSeleccionados?.[texto2]?.[a] || false}
                  onChange={() => {
                    setDocsSeleccionados(prev => {
                      const actualizado = { ...prev };
                      const carpeta = actualizado[texto2] ? { ...actualizado[texto2] } : {};

                      if (carpeta[a]) {
                        delete carpeta[a];
                        if (Object.keys(carpeta).length === 0) {
                          delete actualizado[texto2];
                        } else {
                          actualizado[texto2] = carpeta;
                        }
                      } else {
                        carpeta[a] = true;
                        actualizado[texto2] = carpeta;
                      }

                      return actualizado;
                    });
                  }}
                />
                <span className='slider round'></span>
              </label>
            )}
          </div>
        ))}
      </div>
      <div style={{ marginTop: 'auto' }}>
        <p className={theme === 1 ? 'textoObservaciones' : 'textoObservacionesDark'}>OBSERVACIONES PARA EL USUARIO</p>
        <textarea
          className={theme ? 'contenedorObservaciones' : 'contenedorObservacionesDark'}
          disabled={cookies?.user?.titulo === 'lector'}
          value={obs?.[texto2] || ''}
          onChange={e => {
            const nuevoValor = e.target.value;
            setObs(prev => ({
              ...prev,
              [texto2]: nuevoValor,
            }));
            if (nuevoValor.trim() !== '' && estadoDocs[texto2] !== 903) {
              setEstadoDocs(prev => ({ ...prev, [texto2]: 903 }));
            }
            setModoEliminarDocs(prev => ({
              ...prev,
              [texto2]: nuevoValor.trim() !== '' || estadoDocs[texto2] === 903,
            }));
          }}
        />
      </div>
      <div style={{ marginTop: '10px' }}>
        <div className='d-flex'>
          <i className={theme === 1 ? 'bi bi-clock ultModDocSinAbrir' : 'bi bi-clock ultModDocSinAbrirDark'}></i>
          <p className={theme === 1 ? 'ultModDocSinAbrir' : 'ultModDocSinAbrirDark'} style={{ marginLeft: '7px' }}>
            Ult Mod {ultMod}
          </p>
        </div>
      </div>
    </article>
  );
}
